import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Organization } from "../../../common/models/organization";
import { User } from "../../../common/models/user";
import { OrganizationRole } from "../../../common/models/organization-role";
import { ConfigProvider } from "../../../config-provider.service";
import { UsersUserProfileDialogComponent } from "../../../users/components/user-profile-dialog/user-profile-dialog";
import { MatCard } from "@angular/material/card";
import { MatRipple } from "@angular/material/core";
import { NgForOf, NgIf } from "@angular/common";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'organizations-organization-member-card',
  providers: [],
  styleUrls: ['./organization-member-card.scss'],
  standalone: true,
  imports: [
    MatCard,
    MatRipple,
    NgIf,
    MatIcon,
    NgForOf
  ],
  templateUrl: './organization-member-card.html'
})
export class OrganizationsOrganizationMemberCardComponent implements AfterViewInit {
    @Input() public organization: Organization = new Organization({});
    @Input() public user: User = new User({});
    @Input() public roles: OrganizationRole[] = [];
    constructor(
        public conf: ConfigProvider,
        private _dialoger: MatDialog,
        private _translater: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }

    public onClicked(): void {
        const dialog: MatDialogRef<any> = this._dialoger.open(UsersUserProfileDialogComponent, {
            data: {
                user: this.user,
                organization: this.organization
            }
        });
    }
}
